<button matIconButton matTooltip="{{ 'menu.preferences' | translate }}">
    <mat-icon aria-hidden="false">manage_accounts</mat-icon>
</button>